import { Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import DefaultLayout from "./components/Layout/DefaultLayout";
import { routes } from "./routes";
import { LoadingOutlined } from "@ant-design/icons";
import { Flex, Spin } from "antd";
import "./App.css";
import Loader from "./components/generic/Loader";
import { useDispatch } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { useAuthModule } from "@data-phone/react-resource-server-auth"
import { setSessionData } from "./store/slices/sessionData.slice";
import { usePermissions } from "./hooks/permissions";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;


function App() {
  const dispatch: Dispatch = useDispatch()
  const { logout, data } = useAuthModule()
  const [isLoading, setIsLoading] = useState(true);
  const { hasPermission, hasPermission2 } = usePermissions();

  useEffect(() => {
    if (typeof Notification === "undefined") {
      return;
    }
    Notification.requestPermission();
  }, [])

  useEffect(() => {
    if (data.sessionData) {
      dispatch(setSessionData(data.sessionData))
      setIsLoading(false);
    }
  }, [data.sessionData])


  if (isLoading) {
    return (
      <Flex style={{ height: "100vh" }}>
        {" "}
        <Loader />
      </Flex>
    );
  }

  return (
    <Routes>
      <Route element={<DefaultLayout logout={logout} />}>
        {routes.filter((route) => !route.permissions || hasPermission(route.permissions?.type, route.permissions?.permissions) || (!!route.permissions?.permission2 && !!route.permissions?.permissionScope && hasPermission2(route.permissions.permission2, route.permissions.permissionScope))).map((routes, index) => {
          const { path, component: Component } = routes;
          return (
            <Route
              key={index}
              path={path}
              element={
                <Suspense fallback={<Spin indicator={antIcon} />}>
                  <Component />
                </Suspense>
              }
            />
          );
        })}
      </Route>
    </Routes>
  );
}

export default App;
